<script lang="ts">
  import ModalPictureTextAction from '$components/modal-picture-text-action/ModalPictureTextAction.svelte';
  import { closeModal } from '$components/bottom-sheet/index.svelte';
  import Button from '$components/button/Button.svelte';
  import IconDotsVertical from '$lib/icons/IconDotsVertical.svelte';
  import Image from '$lib/assets/banner-add-to-home-screen-android.webp';
</script>

<ModalPictureTextAction>
  {#snippet image()}
    <img src={Image} alt="Metri" class="mx-auto w-full" />
  {/snippet}
  {#snippet title()}
    Add Metri to your Home Screen
  {/snippet}
  {#snippet paragraph()}
    To add Metri to your Home Screen, tap the <IconDotsVertical class="relative inline h-4!" /> icon
    in the Chrome Browser and then “Add to Home Screen”.
  {/snippet}
  {#snippet action()}
    <Button ariaLabel="Close" stretched variant="secondary" onclick={closeModal}>Close</Button>
  {/snippet}
</ModalPictureTextAction>
